<template>
  <div class="header__notification">
    <div v-if="activateUndo" class="undo-popup" :class="activateUndo ? 'fade__in' : 'fade__out'">
      <div>
        <span class="close" @click="hideUndoPopup"><i class="fas fa-times"></i></span>
        <span class="undo__text text-primary fw-bold">{{ activateUndoText }}</span>
        <b-button
          class="header-filter-btns float-right"
          variant="theme"
          @click="undo"
        >
          <span v-if="!isMobile()">Undo</span>
          <i class="fas fa-undo" v-if="isMobile()"></i>
          <span class="sec float-right">10</span>
        </b-button>
      </div>
    </div>
    <b-modal size="lg" hide-footer id="globalAlertDetail" class="modal-global-alert-detail">
      <template slot="modal-title">
        {{alertTitle}}
        <p v-if="alertTime != ''"
          class="notification-sender"
        >sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) | moment('MMM Do, hh:mm a') }}</p>
      </template>
      <span v-html="alertDetail"></span>
    </b-modal>
    <b-modal size="xl" hide-footer id="editDeliverableModalAlert" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditModal 
        :allContacts="allContacts" 
        modalId="editDeliverableModalAlert"  
        ref="refEditModal" 
        :namespace="''" 
        :tabIndex="tabIndex" 
        />
    </b-modal>
    <div class="dropdown">
      <div
        class="icon cursor-pointer dropdown-toggle mr-2"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        @click="updatePerfectScroll"
      >
        <span v-if="notificationCount" class="notification-count"></span>
        <img
          :class="notificationCount > 0 && !$store.state.deliverables.newNotificationPopupClose ? 'animated' : ''"
          width="30px"
          src="@/csmworkflow/img/bell-module.svg"
        />
      </div>
      <span class="new__notification__popup" 
      v-if="notificationCount > 0 && !$store.state.deliverables.newNotificationPopupClose" 
      :class="newNotificationPopup ? 'fade__in' : 'fade__out'">
        <div @click="$router.currentRoute.name != 'userGlobalAlert' ? $router.push({ name: 'userGlobalAlert' }) : ''; $store.state.deliverables.newNotificationPopupClose=true" 
        class="dropdown-item notification-title text-primary text-center cursor-pointer">
          <span class="close" @click.stop="handlePopupClose">
            <i class="fas fa-times"></i>
          </span>
          <span style="font-weight: normal !important" v-if="notificationCount == 1">You have a new notification.</span>
          <span style="font-weight: normal !important" v-if="notificationCount > 1">You have <span class="fw-bold">{{ notificationCount }}</span> new notifications.</span>
        </div>
      </span>
      <div class="dropdown-menu" :class="notificationList.length == 0 ? 'no__notification__popup' : ''">
        <div >
          <div class="dropdown-item notification-title text-primary">
            Notifications
            <span class="float-right view-all">
              <router-link 
              href="#" class="dropdown-item" 
              :to="{ name: 'userGlobalAlert' }"
              >View All</router-link>
            </span>
          </div>
          <perfect-scrollbar ref="notification__scroll">
            <span>
              <a
                @click.prevent="onNotificationClick(alert)"
                class="dropdown-item notification-item"
                :class="alert.status == 1 ? 'read' : ''"
                :key="'userAlert-'+index"
                v-for="(alert, index) in notificationList"
                href="#"
              >
                <span class="notification-icon-wrapper">
                  <img
                    v-if="getDeliverableIdFromAlert(alert)"
                    src="@/csmworkflow/img/project-deliverable-white.svg"
                    class="notification-icon"
                    alt="Deliverable"
                  />
                  <i
                    v-else-if="getProjectIdFromAlert(alert)"
                    class="fas fa-folder fa-fw notification-icon-fa"
                    aria-hidden="true"
                  ></i>
                  <img
                    v-else
                    src="@/csmworkflow/img/bell-regular.svg"
                    class="notification-icon"
                    alt="Notification"
                  />
                </span>
                <span class="notification-details" v-if="isNonGeneralAlert(alert)">
                  <span class="notification-title">{{ alert.title }}</span>
                  <span v-if="alert.alert_type == 'chat' || alert.alert_type == 'project-chat' || alert.alert_type == 'deliverable-chat'">sent by {{ alert.sender }}.</span>

                  <br v-if="alert.task_count > 0 || alert.chat_count > 0 || alert.update_count > 0">
                  <span class="notification-sender" v-if="alert.task_count > 0">
                    +{{ alert.task_count }} 
                    {{ pluralize(alert.task_count, 'task update', 'task updates') }}<template v-if="shouldAddComma(alert, 'task_count')">,</template>
                  </span>

                  <span class="notification-sender" v-if="alert.chat_count > 0">
                    +{{ alert.chat_count }} 
                    {{ pluralize(alert.chat_count, 'message', 'messages') }}<template v-if="shouldAddComma(alert, 'chat_count')">,</template>
                  </span>

                  <span class="notification-sender" v-if="alert.update_count > 0">
                    +{{ alert.update_count }} 
                    {{ pluralize(alert.update_count, 'update', 'updates') }}<template v-if="shouldAddComma(alert, 'update_count')">,</template>
                  </span>

                  <p class="notification-time-row">
                    <span class="notification-time">{{ fromNowDate(getLocalAlertTime(alert.created_at)) }}</span>
                    <a
                      v-if="shouldShowProjectButton(alert)"
                      href="#"
                      class="notification-view-link"
                      @click.stop.prevent="openProjectFromAlert(alert)"
                    >
                      View Project
                    </a>
                    <a
                      v-else-if="shouldShowDeliverableButton(alert)"
                      href="#"
                      class="notification-view-link"
                      @click.stop.prevent="openDeliverableFromAlert(alert)"
                    >
                      View Deliverable
                    </a>
                  </p>
                </span>
                <span class="notification-details" v-else>
                  <!-- system updates and general alerts created by super admin -->
                  <span class="notification-title">{{ alert.title }}</span>
                  <span>sent by {{ alert.sender }}.</span>
                  <p class="notification-time-row">
                    <span class="notification-time">{{ fromNowDate(getLocalAlertTime(alert.created_at)) }}</span>
                  </p>
                </span>
              </a>
            </span>
          </perfect-scrollbar>
        </div>
        <div v-if="notificationList.length == 0">
          <span class="dropdown-item notification-title text-center">You have no unread notifications.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import EditModal from "../deliverables/EditModal";
export default {
  components: {
    EditModal
  },
  data() {
    return {
      alertTitle: "",
      alertDetail: "",
      alertSender: "",
      alertTime: "",
      enableAnimation: false,
      newNotificationPopup: true,
      tabIndex: 0,
    };
  },
  mounted() {
    let that = this;
    this.fetchNotification({ userId: localStorage.getItem("userId") });

    this.$root.$on('bv::modal::shown', (bvEvent, modalId) => {
      if (modalId == 'editDeliverableModalAlert') {
        if (this.taskHighlighted) {
            let editModal = $("#editDeliverableModalAlert");

            this.$nextTick(() => {
              setTimeout(() => {
                let curEl = $(".task-fields .field-block.highlight");
                const elOffset = curEl.offset();
                editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
              }, 100);
            });
        }
      }
    });

    $("body").on("click", "#update-logout", function (e) {
      e.preventDefault();
      let alertId = $(this).data("alertid");
      that.$store.dispatch("makeAlertRead", {
        alert: { id: alertId, loggedout: "true" },
      });
      that.$store.dispatch("logout").then(() => that.$router.push("/login"));
    });
    Echo.channel("notification").listen("NotificationAdded", () => {
      this.$store.dispatch("fetchUserAlerts");
      this.$store.dispatch("fetchAlerts");
    });
    Echo.channel("newnotification").listen("NotificationAdded", () => {
      this.$store.dispatch("fetchNotification", {
        userId: localStorage.getItem("userId"),
      });
      this.$store.state.deliverables.newNotificationPopupClose=false;
      this.newNotificationPopup = true;
      this.notificationAnimation();
    });
    this.notificationAnimation();
  },
  computed: {
    ...mapGetters([
      "notification",
      'activateUndoText',
      'activateUndo',
      'deliverableDetail',
      'allContacts',
      'taskHighlighted'
    ]),
    ...mapState({
      getDeliverableTemplateSlug(state, getters) {
        return getters['getDeliverableTemplateSlug']
      },
    }),
    notificationCount() {
      let count = 0;
      if (typeof this.notificationList != "undefined" && this.notificationList.length > 0) {
        this.notificationList.forEach(function (value, key) {
          if (value.status == 0) {
            count++;
          }
        });
      }

      if (count > 0) {
        this.enableAnimation = true;
        let currentTitle = document.title.match(/\(\d+\)\s?/g);
        if (!currentTitle) {
          document.title = "(" + count + ") " + document.title;
        } else {
          document.title =
            "(" +
            count +
            ") " +
            document.title.substr(currentTitle[0].length);
        }
      } else {
        let currentTitle = document.title.match(/\(\d+\)\s?/g);
        if (currentTitle) {
          document.title = document.title.substr(currentTitle[0].length);
        }
      }

      return count;
    },
    notificationList() {
      const n = this.notification;
      if (Array.isArray(n)) return n;
      if (n && Array.isArray(n.data)) return n.data;
      return [];
    },
  },
  methods: {
    ...mapActions([
      "fetchNotification",
      'fetchProjectDeliverableById',
      'getProjectNumberFromId',
      'getProjectNumberFromDeliverableId',
      'getDeliverableDetail',
      'getDeliverableDetailByTask',
      'makeAlertRead'
    ]),
    ...mapMutations(['setDataLoading']),
    hideUndoPopup() {
      this.$store.commit('setActivateUndo', false);
    },
    shouldAddComma(alert, type) {
      const types = ['task_count', 'chat_count', 'update_count'];
      const currentIndex = types.indexOf(type);
      // there are 8 possible combinations
      // Check if there is a next type with a count > 0
      for (let i = currentIndex + 1; i < types.length; i++) {
        if (alert[types[i]] > 0) {
          return true;
        }
      }
      return false;
    },
    pluralize(count, singular, plural) {
      return count === 1 ? singular : plural;
    },
    undo() {
      let self = this;
      this.$store.dispatch('undoAction').then(function() {
        if(self.$router.currentRoute.name == 'globalSearch') {
          let currentPageNumber = localStorage.getItem('currentPageNumber');
          let currentGSTab = localStorage.getItem('currentGSTab');
          self.$store.dispatch('globalSearch', {type: currentGSTab, page: currentPageNumber});
        }
      });
      this.hideUndoPopup();
    },
    handlePopupClose() {
      this.newNotificationPopup=false;
      this.$store.state.deliverables.newNotificationPopupClose=true;
    },
    updatePerfectScroll() {
      let self = this;
      self.handlePopupClose();
      setTimeout(function () {
        if(typeof self.$refs.notification__scroll != 'undefined') {
          self.$refs.notification__scroll.update();
        }
      }, 1);
    },
    notificationAnimation() {
      let self = this;
      let animationTimeout = setTimeout(function () {
        $(".header__notification .icon img").removeClass("animated");
        self.enableAnimation = false;
        stopAnimation();
      }, 18000);
      function stopAnimation() {
        clearTimeout(animationTimeout);
      }
    },
    onNotificationClick(alert) {
      if (alert && alert.status === 0) {
        const isUserGlobalAlertPage = this.$router && this.$router.currentRoute && this.$router.currentRoute.name === 'userGlobalAlert';
        this.makeAlertRead({ alert, silent: isUserGlobalAlertPage });
        alert.status = 1;
      }
      this.goToNotifications(alert);
    },
    goToNotifications(alert) {
      const route = { name: 'userGlobalAlert', query: {} };
      const projectId = this.getProjectIdFromAlert(alert);
      const deliverableId = this.getDeliverableIdFromAlert(alert);
      const deliverableGroupId = alert && alert.deliverable_group_id ? alert.deliverable_group_id : deliverableId;

      const alertTypeSlug = alert ? (alert.alert_type_slug || alert.alert_type) : null;
      const isGlobalAlert = alert && (alertTypeSlug === 'general' || alertTypeSlug === 'system-update' || alert.alert_model === 'global_alert');

      if (isGlobalAlert) {
        route.query.group_by = 'date';
      } else if (deliverableGroupId) {
        route.query.group_by = 'deliverable';
        route.query.expandGroupKey = `deliverable-${deliverableGroupId}`;
      } else if (projectId) {
        route.query.group_by = 'project';
        route.query.expandGroupKey = `project-${projectId}`;
      }

      if (alert && alert.id) {
        route.query.focusAlertId = String(alert.id);
      }

      this.$router.push(route);
    },
    getDeliverableIdFromAlert(alert) {
      if (!alert) return null;
      if (alert.grouped_model === 'deliverable' && alert.grouped_model_id) {
        return alert.grouped_model_id;
      }
      if (alert.alert_model === 'task' && alert.model_id) {
        return alert.model_id;
      }
      return null;
    },
    getProjectIdFromAlert(alert) {
      if (!alert) return null;
      if (alert.grouped_model === 'project' && alert.grouped_model_id) {
        return alert.grouped_model_id;
      }
      return null;
    },
    shouldShowProjectButton(alert) {
      return Boolean(this.getProjectIdFromAlert(alert));
    },
    shouldShowDeliverableButton(alert) {
      const deliverableId = this.getDeliverableIdFromAlert(alert);
      if (!deliverableId) return false;
      if (alert && alert.grouped_model === 'deliverable') return true;
    },
    openProjectFromAlert(alert) {
      const projectId = this.getProjectIdFromAlert(alert);
      if (projectId) {
        this.goToProject(projectId);
        return;
      }
      this.goToNotifications(alert);
    },
    async openDeliverableFromAlert(alert) {
      if (!alert) return;
      const chatModels = ['chat', 'project-chat', 'deliverable-chat'];
      const isChat = chatModels.includes(alert.alert_model) ? '1' : undefined;

      const isDeliverableAlert =
        (alert.alert_model === "deliverable" || alert.grouped_model === "deliverable") &&
        alert.alert_model !== "task";

      try {
        if (isDeliverableAlert) {
          const deliverableId = alert.grouped_model === "deliverable" ? alert.grouped_model_id : alert.model_id;
          await this.getDeliverableDetail({ deliverableId });
          const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
          const projectId = this.deliverableDetail.project_id?.id || this.deliverableDetail.project_id || this.deliverableDetail.project?.id;
          if (isChat && deliverableTemplateSlug === "media-call") {
            const query = { openDeliverable: deliverableId, templateSlug: deliverableTemplateSlug, isChat };
            this.$router.push({ path: '/media-calls', query }).catch(() => {});
            return;
          }

          if (projectId) {
          	console.log("deliverableTemplateSlug", deliverableTemplateSlug);

            await this.goToProject(projectId, { openDeliverable: deliverableId, templateSlug: deliverableTemplateSlug, isChat });
            return;
          }

          const data = await this.getProjectNumberFromDeliverableId(deliverableId);
          if (data && data.project_number) {
            await this.openProjectByNumber(data.project_number, { openDeliverable: deliverableId, templateSlug: deliverableTemplateSlug, isChat });
            return;
          }
        } else if (alert.alert_model === "task") {
          const taskId = alert.model_id;
          await this.getDeliverableDetailByTask({ taskId });

          const deliverableId = this.deliverableDetail?.id;
          const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
          const projectId = this.deliverableDetail.project_id?.id || this.deliverableDetail.project_id || this.deliverableDetail.project?.id;

          if (deliverableTemplateSlug === "media-call") {
            const query = { openDeliverable: deliverableId, templateSlug: deliverableTemplateSlug, highlightTask: taskId };
            this.$router.push({ path: '/media-calls', query }).catch(() => {});
            return;
          }

          if (projectId) {
            await this.goToProject(projectId, { openDeliverable: deliverableId, highlightTask: taskId });
            return;
          }

          if (deliverableId) {
            const data = await this.getProjectNumberFromDeliverableId(deliverableId);
            if (data && data.project_number) {
              await this.openProjectByNumber(data.project_number, { openDeliverable: deliverableId, highlightTask: taskId });
              return;
            }
          }
        } else if (alert.alert_model === "project" || alert.grouped_model === "project" || alert.alert_model === "project-chat") {
          const projectId = this.getProjectIdFromAlert(alert);
          if (projectId) {
            await this.goToProject(projectId);
            return;
          }
        }
      } catch (e) {
        // Fall through to notifications
      }

      this.goToNotifications(alert);
    },

    navigateToProjectInPlace(projectNumber, query = {}) {
      if (!projectNumber) return;
      const cleaned = Object.keys(query).reduce((acc, key) => {
        const value = query[key];
        if (value === undefined || value === null || value === '') return acc;
        acc[key] = String(value);
        return acc;
      }, {});

      if (this.$router) {
        this.$router.push({ path: `/project/${projectNumber}`, query: cleaned }).catch(() => {});
        return;
      }

      const qs = new URLSearchParams(cleaned).toString();
      const suffix = qs ? `?${qs}` : '';
      window.location.href = `${window.location.origin}/project/${projectNumber}${suffix}`;
    },

    async openProjectByNumber(projectNumber, query = {}) {
      if (!projectNumber) return;
      this.setDataLoading(true);
      try {
        await this.fetchProjectDeliverableById(projectNumber);
        this.setDataLoading(false);
        const isNumber = !isNaN(Number(projectNumber));
        if (isNumber) {
          this.navigateToProjectInPlace(projectNumber, query);
        }
      } catch (e) {
        this.setDataLoading(false);
      }
    },

    async goToProject(projectId, query = {}) {
      this.setDataLoading(true);
      try {
        const projectNumber = await this.getProjectNumberFromId(projectId);
        await this.fetchProjectDeliverableById(projectNumber);
        this.setDataLoading(false);
        const isNumber = !isNaN(Number(projectNumber));
        if (isNumber) {
          this.navigateToProjectInPlace(projectNumber, query);
        }
      } catch (e) {
        this.setDataLoading(false);
      }
    },

    isNonGeneralAlert(alert) {
      return alert.alert_model !== "general" && alert.alert_model !== "system-update";
    },

    getLocalAlertTime(time) {
   		if (time != null && time != "") {
	        const alertTime = this.$moment.utc(time);
	        alertTime.local();
	        return alertTime;
      } else {
      	return null;
      }
    },

    // Deliverable modal related
    editDeliverableModalHidden() {
      this.$store.commit('setDeliverable', this.deliverableDetail)
    },
    pushRoute() {
      if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
        history.pushState(
          {},
          null,
          'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
        )
      }
    },
    removeRoute() {
      if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
        this.$router.push({name: 'dashboard'});
      } else {
        history.pushState(
          {},
          null,
          this.$router.currentRoute.path
        );
        //this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
      }
    },
  },
};
</script>

<style scoped>
.notification-item{
  font-size: 0.8rem;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.notification-details {
  flex: 1;
}

.notification-icon-wrapper {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--wf-primary);
  flex-shrink: 0;
}

.notification-icon {
  width: 16px;
  height: 16px;
}

.notification-icon-fa {
  font-size: 16px;
  color: #fff;
}

.notification-time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.25rem 0 0;
}

.notification-view-link {
  color: var(--wf-primary);
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  margin-left: 10px;
}

.notification-view-link:hover {
  text-decoration: underline;
}
</style>
